import { useTemplate } from "PFCore/helpers/templates";

import { useActivityPageContext } from "../activity_page_context";

export const useActivityTemplate = () => {
  const { task: activity } = useActivityPageContext();
  return useTemplate(activity?.template_id);
};
